<template>
    <aside
    id="sidebarMenu"
    class="d-none d-md-flex sidebar"
    :class="[{ collapse }]"
    >
        <div class="d-flex flex-column header-custom">
        <div class="logo-custom">
            <img
            :src="customCorporateLogo"
            alt=""
            height="50"
            class="position-absolute top-50 start-50 translate-middle"
            />
        </div>
        <div class="logo-custom-collapse" :class="[{ collapse }]">
            <img
            :src="customCollapseCorporateLogo"
            alt=""
            height="20"
            class="position-absolute top-50 start-50 translate-middle"
            />
        </div>
        <div class="profile-info mt-3">
            <div class="small" v-if="businessProfile?.corporate_name">
            {{ businessProfile.corporate_name }}
            </div>
            <div class="small" v-if="businessProfile?.branch_name">
            {{ businessProfile.branch_name }}
            </div>
            <div class="small" v-if="businessProfile?.merchant_name">
            {{ businessProfile.merchant_name }}
            </div>
        </div>
        <div class="menu-custom">
            <div class="position-sticky pt-3">
            <ul class="nav flex-column">
                <li class="nav-item" v-for="list in filteredMenuVisibility" :key="list.i">
                <div v-if="list.link_name === 'Voucher' && voucherSubItems.length > 1">
                    <a 
                        href="javascript:void(0)" 
                        class="nav-link accordion-header" 
                        :class="[
                            isVoucherActive ? 'active router-link-active' : '',
                            isFeatureLocked('Voucher') ? 'menu-locked-disabled' : ''
                        ]"
                        @click="toggleVoucher"
                    >
                        <div class="d-inline-block me-3">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-ticket-perforated"
                                viewBox="0 0 16 16"
                            >
                                <path
                                d="M4 4.85v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Z"
                                />
                                <path
                                d="M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3h-13ZM1 4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1.05a2.5 2.5 0 0 0 0 4.9v1.05a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1.05a2.5 2.5 0 0 0 0-4.9V4.5Z"
                                />
                            </svg>
                        </div>
                        <span class="menu-link-name">Voucher</span>
                        <i v-if="isFeatureLocked('Voucher')" class="fas fa-lock ms-2 lock-icon"></i>
                        <i class="fas fa-chevron-right ms-auto accordion-icon" :class="{ 'rotated': isVoucherExpanded }"></i>
                    </a>
                    <div v-show="isVoucherExpanded" class="sub-menu-container">
                        <ul class="nav flex-column mb-2 submenu-tree">
                            <li class="nav-item" v-for="sub in voucherSubItems" :key="sub.link_name">
                                <router-link
                                    :to="sub.link_spesific"
                                    class="nav-link sub-link d-flex align-items-center"
                                    :class="{ 
                                        'active': isActiveVoucherChild(sub.link_spesific),
                                        'menu-locked-disabled': isFeatureLocked(sub.link_name)
                                    }"
                                >
                                    <div v-if="sub.link_name === 'Management'" class="d-inline-block me-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-card-list" viewBox="0 0 16 16">
                                            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                                            <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
                                        </svg>
                                    </div>
                                    <div v-else-if="sub.link_name === 'Voucher Redeem'" class="d-inline-block me-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-bag-check" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                                            <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>
                                        </svg>
                                    </div>
                                    <div v-else-if="sub.link_name === 'Voucher Gift'" class="d-inline-block me-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-gift" viewBox="0 0 16 16">
                                            <path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5V7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zM1 4v2h6V4H1zm8 0v2h6V4H9zm5 3H9v8h4.5a.5.5 0 0 0 .5-.5V7zm-7 8V7H2v7.5a.5.5 0 0 0 .5.5H7z"></path>
                                        </svg>
                                    </div>
                                    <span class="flex-grow-1">{{ sub.link_name }}</span>
                                    <i v-if="isFeatureLocked(sub.link_name)" class="fas fa-lock ms-2 lock-icon"></i>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <router-link
                    v-else-if="!list.is_dropdown"
                    :to="list.link_spesific"
                    class="nav-link"
                    :class="{ 
                        'router-link-active': isRouteActive(list.link_spesific),
                        'menu-locked-disabled': isFeatureLocked(list.link_name)
                    }"
                    aria-current="page"
                >
                    <div
                    v-if="list.link_name === 'Dashboard'"
                    class="d-inline-block me-3"
                    >
                    <svg 
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor" 
                        viewBox="0 0 16 16"
                    >
                        <path d="M14 7.032c0 3.642-3.134 6.595-7 6.595s-7-2.953-7-6.595C0 3.389 3.134.437 7 .437s7 2.952 7 6.595Zm-6.344.945V2.704c0-.341-.292-.618-.656-.618-.364 0-.656.277-.656.618v5.273C5.7 8.22 5.25 8.812 5.25 9.505c0 .91.785 1.649 1.75 1.649s1.75-.74 1.75-1.65c0-.692-.451-1.285-1.094-1.527ZM3.938 4.971c.483 0 .874-.368.874-.824 0-.456-.39-.825-.875-.825-.483 0-.874.369-.874.825 0 .456.39.824.874.824ZM2.625 6.207c-.483 0-.875.369-.875.825 0 .456.392.824.875.824.484 0 .875-.368.875-.824 0-.456-.391-.825-.875-.825Zm8.75 1.65c.484 0 .875-.37.875-.825 0-.456-.391-.825-.875-.825s-.875.369-.875.825c0 .456.391.824.875.824Zm-1.313-4.535c-.483 0-.874.369-.874.825 0 .456.39.824.874.824.485 0 .876-.368.876-.824 0-.456-.392-.825-.876-.825Z"/>
                        </svg>
                    </div>
                    <div
                    v-if="list.link_name === 'Merchant'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-shop-window"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h12V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zm2 .5a.5.5 0 0 1 .5.5V13h8V9.5a.5.5 0 0 1 1 0V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a.5.5 0 0 1 .5-.5z"
                        />
                    </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Branch Product'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-basket2-fill"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M5.929 1.757a.5.5 0 1 0-.858-.514L2.217 6H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.623l1.844 6.456A.75.75 0 0 0 3.69 15h8.622a.75.75 0 0 0 .722-.544L14.877 8h.623a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.717L10.93 1.243a.5.5 0 1 0-.858.514L12.617 6H3.383L5.93 1.757zM4 10a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm3 0a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm4-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
                        />
                    </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Business Profile'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-person-bounding-box"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"
                        />
                        <path
                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                        />
                    </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'User'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-person-plus-fill"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                        />
                        <path
                        fill-rule="evenodd"
                        d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                        />
                    </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Corporate'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-building"
                        viewBox="0 0 16 16"
                    >
                        <path
                        fill-rule="evenodd"
                        d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"
                        />
                        <path
                        d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z"
                        />
                    </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Feature Flags'"
                    class="d-inline-block me-3"
                    >
                        <i class="fas fa-flag" style="font-size: 16px; width: 16px; height: 16px; color: currentColor;"></i>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Branch'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-diagram-3-fill"
                        viewBox="0 0 16 16"
                    >
                        <path
                        fill-rule="evenodd"
                        d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"
                        />
                    </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Member'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-people-fill"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                        />
                        <path
                        fill-rule="evenodd"
                        d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
                        />
                        <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                    </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Product'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-basket2-fill"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M5.929 1.757a.5.5 0 1 0-.858-.514L2.217 6H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.623l1.844 6.456A.75.75 0 0 0 3.69 15h8.622a.75.75 0 0 0 .722-.544L14.877 8h.623a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.717L10.93 1.243a.5.5 0 1 0-.858.514L12.617 6H3.383L5.93 1.757zM4 10a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm3 0a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm4-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
                        />
                    </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Point Plan'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-calendar2-check-fill"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-2.6 5.854a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                        />
                    </svg>
                    </div>
                    <div v-else-if="list.link_name === 'Marketing'" class="d-inline-block me-3">
                        <i class="fas fa-bullhorn"></i>
                    </div>
                    <div v-else-if="list.link_name === 'Promotions'" class="d-inline-block me-3">
                        <i class="fas fa-tags"></i>
                    </div>
                    <div v-else-if="list.link_name === 'Newsletter'" class="d-inline-block me-3">
                        <i class="fas fa-newspaper"></i>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Transaction'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-cash-coin"
                        viewBox="0 0 16 16"
                    >
                        <path
                        fill-rule="evenodd"
                        d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
                        />
                        <path
                        d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z"
                        />
                        <path
                        d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z"
                        />
                        <path
                        d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z"
                        />
                    </svg>
                    </div>
                    <div
                        v-else-if="list.link_name === 'Point Manipulation'"
                        class="d-inline-block me-3"
                    >
                        <i class="far fa-money-bill-alt" style="font-size: 16px; width: 16px; height: 16px; color: currentColor"></i>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Benefit'"
                    class="d-inline-block me-3"
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                      </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Voucher'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-ticket-perforated"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M4 4.85v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Z"
                        />
                        <path
                        d="M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3h-13ZM1 4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1.05a2.5 2.5 0 0 0 0 4.9v1.05a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1.05a2.5 2.5 0 0 0 0-4.9V4.5Z"
                        />
                    </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Voucher Redeem'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-ticket-perforated-fill"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5Zm4-1v1h1v-1H4Zm1 3v-1H4v1h1Zm7 0v-1h-1v1h1Zm-1-2h1v-1h-1v1Zm-6 3H4v1h1v-1Zm7 1v-1h-1v1h1Zm-7 1H4v1h1v-1Zm7 1v-1h-1v1h1Zm-8 1v1h1v-1H4Zm7 1h1v-1h-1v1Z"
                        />
                    </svg>
                    </div>
                    <div v-else-if="list.link_name === 'Voucher Gift'" class="d-inline-block me-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gift" viewBox="0 0 16 16">
                            <path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5V7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zM1 4v2h6V4H1zm8 0v2h6V4H9zm5 3H9v8h4.5a.5.5 0 0 0 .5-.5V7zm-7 8V7H2v7.5a.5.5 0 0 0 .5.5H7z"/>
                        </svg>
                    </div>
                    <div v-else-if="list.link_name === 'Voucher Gift History'" class="d-inline-block me-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gift-fill" viewBox="0 0 16 16">
                            <path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5V7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zm6 1h-5v2h5V4zM1 6h5V4H1v2zm6 1v7.5a.5.5 0 0 0 .5.5H9V7H7zm3 7.5V7h-1v8h3.5a.5.5 0 0 0 .5-.5V7h-1v7.5a.5.5 0 0 1-.5.5H10z"/>
                        </svg>
                    </div>
                    <div
                        v-else-if="list.link_name === 'Tax Service'"
                        class="d-inline-block me-3"
                    >
                        <i class="fas fa-file-invoice" style="font-size: 16px; width: 16px; height: 16px;"></i>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Switch'"
                    class="d-inline-block me-3"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-toggle-on"
                            viewBox="0 0 16 16"
                        >
                            <path
                            d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10H5zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
                            />
                        </svg>
                    </div>
                    <div
                    v-else-if="list.link_name === 'Access Token'"
                    class="d-inline-block me-3"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-key" viewBox="0 0 16 16">
                            <path d="M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8zm4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5z"/>
                            <path d="M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                        </svg>
                    </div>
                    <div
                        v-else-if="list.link_name === 'Authentication URL'"
                        class="d-inline-block me-3"
                    >
                        <i class="fas fa-user-shield"></i>
                    </div>
                    <div
                    v-if="list.link_name === 'System Log'"
                    class="d-inline-block me-3"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-journal-text"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
                        />
                        <path
                        d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"
                        />
                        <path
                        d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
                        />
                    </svg>
                    </div>
                    <div
                        v-if="list.link_name === 'API Log'"
                        class="d-inline-block me-3"
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-code" viewBox="0 0 16 16">
                            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z"/>
                            <path d="M8.646 6.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 9 8.646 7.354a.5.5 0 0 1 0-.708m-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 9l1.647-1.646a.5.5 0 0 0 0-.708"/>
                        </svg>
                    </div>
                    <div
                        v-if="list.link_name === 'Member Tier'"
                            class="d-inline-block me-3"
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z"/>
                        </svg>
                    </div>
                    <div
                      v-if="list.link_name === 'User Roles'"
                        class="d-inline-block me-3"
                      >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill-gear" viewBox="0 0 16 16">
                        <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4m9.886-3.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"/>
                      </svg>
                    </div>
                    <div v-if="list.link_name === 'Themes'" class="d-inline-block me-3">
                        <i class="fas fa-paint-brush" style="font-size: 16px; color: currentColor;"></i>
                    </div>
                    <div v-if="list.link_name === 'Point System Settings'" class="d-inline-block me-3">
                        <i class="fas fa-cog" style="font-size: 16px; color: currentColor;"></i>
                    </div>
                    <div
                        v-if="list.link_name === 'Transaction Report'"
                            class="d-inline-block me-3"
                        >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-journal-text"
                            viewBox="0 0 16 16"
                        >
                            <path
                            d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
                            />
                            <path
                            d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"
                            />
                            <path
                            d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
                            />
                        </svg>
                    </div>
                    <div
                        v-if="list.link_name === 'Policies'"
                        class="d-inline-block me-3"
                        >
                        <i class="fa fa-balance-scale" style="font-size: 16px; width: 16px; height: 16px;"></i>
                    </div>
                    <div v-else-if="list.link_name === 'Connection Apps'" class="d-inline-block me-3">
                        <i class="fas fa-plug"></i>
                    </div>
                    <span class="menu-link-name">
                    {{ list.link_name === 'Branch Product' ? 'Product' : list.link_name }}
                    </span>
                    <i v-if="isFeatureLocked(list.link_name)" class="fas fa-lock ms-2 lock-icon"></i>
                </router-link>
                
                <div v-else class="nav-dropdown-wrapper">
                    <div
                        class="nav-link"
                        :class="{ 
                            'dropdown-active': openDropdowns.includes(list.link_name),
                            'active': isAnyChildActive(list.children),
                            'menu-locked-disabled': isFeatureLocked(list.link_name)
                        }"
                        style="cursor: pointer; display: flex; align-items: center;"
                        @click="toggleDropdownMenu(list.link_name)"
                    >
                        <div v-if="list.link_name === 'Point Management'" class="d-inline-block me-3">
                            <i class="fas fa-coins" style="font-size: 16px; width: 16px; height: 16px; color: currentColor;"></i>
                        </div>
                        <span class="menu-link-name flex-grow-1">{{ list.link_name }}</span>
                        <!-- lock icon -->
                        <i v-if="isFeatureLocked(list.link_name)" class="fas fa-lock ms-2 lock-icon"></i>
                        <!-- arrow icon -->
                        <i class="fas fa-chevron-down ms-2 dropdown-arrow" :class="{'rotate-up': openDropdowns.includes(list.link_name)}"></i>
                    </div>

                    <!-- children -->
                    <div class="dropdown-children" v-if="openDropdowns.includes(list.link_name) && !collapse">
                        <!-- L shape logic -->
                        <router-link
                            v-for="(child, idx) in list.children" 
                            :key="idx"
                            :to="child.link_spesific"
                            class="nav-link child-link no-indicator"
                            :class="{ 
                                'router-link-active': isRouteActive(child.link_spesific),
                                'menu-locked-disabled': isFeatureLocked(child.link_name)
                            }"
                        >
                            <div class="d-flex align-items-center">
                                <i v-if="child.icon" :class="child.icon" class="me-2 sub-menu-icon"></i>
                                <span class="menu-link-name">{{ child.link_name }}</span>
                                <i v-if="isFeatureLocked(child.link_name)" class="fas fa-lock ms-2 lock-icon"></i>
                            </div>
                        </router-link>
                    </div>
                </div>
                </li>
            </ul>
            </div>
        </div>
        </div>
        <div class="custom-footer">
        <o-user-info :menuvisibility="userinfo" @showModalSwitch="switchmodal" @showPrivacyPolicy="$emit('showPrivacyPolicy')">
        </o-user-info>
        <div class="after-profile-collapse">
            <div class="after-profile-div-collapse">
            <div class="after-profile-setting-collapse">
                <div class="profile-div-inner-collapse">
                <span>
                    <span class="d-inline-flex">
                    <span class="span-custom-collapse">
                        <button @click="toggle" class="for-collapse">
                        <div class="collapsed">
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="white"
                            class="bi bi-arrow-left-circle-fill"
                            viewBox="0 0 16 16"
                            >
                            <path
                                d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
                            />
                            </svg>
                        </div>
                        <div class="uncollapse">
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-arrow-right-circle-fill"
                            viewBox="0 0 16 16"
                            >
                            <path
                                d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                            />
                            </svg>
                        </div>
                        </button>
                    </span>
                    <span class="span-custom-collapse-2">
                        <button @click="toggle" class="for-collapse">Collapse</button>
                    </span>
                    </span>
                </span>
                </div>
            </div>
            </div>
        </div>
        </div>
    </aside>
</template>

<script>
import { 
    OUserInfo
} from '@/components/OmnihControl'

export default {
    props: [
        'collapse',
        'toggle',
        'menuvisibility',
        'userinfo',
        'switchmodal',
    ],
    components: {
        OUserInfo,
    },
    data() {
        return {
            openDropdowns: [],
            businessProfile: null,
            localProfileCache: localStorage.getItem('selected_business_profile'),
            isVoucherExpanded: true
        };
    },
    mounted() {
        this.updateBusinessProfile(); 
        this.initOpenDropdowns();
        window.addEventListener('storage', this.handleStorageChange);
        this.localStorageInterval = setInterval(this.checkLocalStorageChange, 1000);
    },
    beforeUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
        clearInterval(this.localStorageInterval);
    },
    methods: {
        isFeatureLocked(linkName) {
            const featureMap = {
                'Point Management': 'point_control',
                'Point System Settings': 'point_control',
                'Configuration': 'point_control',
                'Manipulation': 'point_control',
                'Expiration': 'point_control',
                'Point Plan': 'point_control',
                'Marketing': 'marketing_module',
                'Transaction Report': 'transaction_report_module',
                'Threshold Setting': 'threshold_setting',
                'Newsletter': 'newsletter_module',
                'Promotions': 'promotions_module',
                'Voucher': 'point_control',
                'Management': 'point_control',
                'Voucher Management': 'point_control',
                'Voucher Redeem': 'point_control',
                'Voucher Gift': 'voucher_gift',
                'Voucher Gift History': 'voucher_gift',
            };
            const featureKey = featureMap[linkName];
            if (!featureKey) return false;

            let flagState = 'ACTIVE';
            if (featureKey === 'marketing_module') {
                flagState = this.$store.getters['FeatureFlag/getMarketingModuleFlag'];
            } else if (featureKey === 'promotions_module') {
                flagState = this.$store.getters['FeatureFlag/getPromotionsModuleFlag'];
            } else if (featureKey === 'newsletter_module') {
                flagState = this.$store.getters['FeatureFlag/getNewsletterModuleFlag'];
            } else if (featureKey === 'point_control') {
                flagState = this.$store.getters['FeatureFlag/getPointControlFlag'];
            } else if (featureKey === 'transaction_report_module') {
                flagState = this.$store.getters['FeatureFlag/getTransactionReportModuleFlag'];
            } else if (featureKey === 'threshold_setting') {
                flagState = this.$store.getters['FeatureFlag/getThresholdSettingFlag'];
            } else if (featureKey === 'voucher_gift') {
                const pointFlag = this.$store.getters['FeatureFlag/getPointControlFlag'];
                if (typeof pointFlag === 'string' && pointFlag.toUpperCase() === 'NONACTIVE') {
                    flagState = 'NONACTIVE';
                } else {
                    flagState = this.$store.getters['FeatureFlag/getVoucherGiftFlag'];
                }
            }

            if (typeof flagState === 'string' && flagState.toUpperCase() === 'NONACTIVE') {
                const upsellContent = this.$store.state['feature-upsell']?.contents?.[featureKey];
                return !!upsellContent && upsellContent.is_active !== false;
            }
            return false;
        },
        toggleDropdownMenu(menuName) {
            const index = this.openDropdowns.indexOf(menuName);
            if (index > -1) {
                this.openDropdowns.splice(index, 1);
            } else {
                this.openDropdowns.push(menuName);
            }
        },
        isAnyChildActive(children) {
            if (!children) return false;
            return children.some(child => this.isRouteActive(child.link_spesific));
        },
        isRouteActive(menuPath) {
            const currentPath = this.$route.path;
            // Exact match atau current path dimulai dengan menu path
            return currentPath === menuPath || currentPath.startsWith(menuPath + '/');
        },
        updateBusinessProfile() {
            const selectedProfile = localStorage.getItem('selected_business_profile');
            if (selectedProfile) {
                let parsedProfile = JSON.parse(selectedProfile);

                // Fallback: If names are missing but IDs exist, try to get from Vuex store
                if (!parsedProfile.corporate_name && parsedProfile.corporate_id) {
                    const profiles = this.$store.state.Auth?.businessProfiles;
                    if (profiles && profiles.corporate) {
                        const corp = profiles.corporate.find(c => c.id == parsedProfile.corporate_id);
                        if (corp) {
                            parsedProfile.corporate_name = corp.name;
                            const branchList = corp.branch || [];
                            const branch = branchList.find(b => b.id == parsedProfile.branch_id);
                            if (branch) {
                                parsedProfile.branch_name = branch.name;
                                const merchantList = branch.merchant || [];
                                const merchant = merchantList.find(m => m.id == parsedProfile.merchant_id);
                                if (merchant) {
                                    parsedProfile.merchant_name = merchant.name;
                                }
                            }
                        }
                    }
                }

                this.businessProfile = parsedProfile;
                this.localProfileCache = selectedProfile;
            } else {
                if (localStorage.getItem('corporate_id')) {
                    const data = {
                        corporate_id: localStorage.getItem('corporate_id') ?? null,
                        branch_id: localStorage.getItem('branch_id') ?? null,
                        merchant_id: localStorage.getItem('merchant_id') ?? null
                    };
                    
                    if (localStorage.getItem('selected_business_profile') === null) {
                        localStorage.setItem('selected_business_profile', JSON.stringify(data));
                    }
                } else {
                    console.error('No selected_business_profile found in localStorage');
                }
            }
        },
        handleStorageChange(event) {
            if (event.key === 'selected_business_profile') {
                this.updateBusinessProfile();
            }
        },
        checkLocalStorageChange() {
            const currentProfile = localStorage.getItem('selected_business_profile');
            if (currentProfile !== this.localProfileCache) {
                this.updateBusinessProfile();
            }
        },
        toggleVoucher() {
            this.isVoucherExpanded = !this.isVoucherExpanded;
        },
        isActiveVoucherChild(link) {
            if (link === '/voucher') {
                return this.$route.path === link || 
                       (this.$route.path.startsWith(link + '/') && 
                        !this.$route.path.startsWith('/voucher/redeem') && 
                        !this.$route.path.startsWith('/voucher/gift'));
            }
            return this.$route.path === link || this.$route.path.startsWith(link + '/');
        },
        initOpenDropdowns() {
            const isPointLocked = this.isFeatureLocked('Point Management');
            const initial = [];
            if (!isPointLocked) {
                initial.push('Point Management');
            }
            if (this.filteredMenuVisibility) {
                this.filteredMenuVisibility.forEach(item => {
                    if (item.children && this.isAnyChildActive(item.children)) {
                        if (!initial.includes(item.link_name)) {
                            initial.push(item.link_name);
                        }
                    }
                });
            }
            this.openDropdowns = initial;

            // collapsed if locked, expanded if unlocked
            const isVoucherLocked = this.isFeatureLocked('Voucher');
            this.isVoucherExpanded = !isVoucherLocked;
        }
    },
    computed: {
        customCollapseCorporateLogo() {
            return window.localStorage?.getItem('corporateLogo') 
                || '/img/Logo.png';

        },
        customCorporateLogo() {
            return window.localStorage?.getItem('corporateLogo') 
                || '/img/Color-Alternate.png';
        },
        filteredMenuVisibility() {
            if (!this.menuvisibility) return [];
            let list = this.menuvisibility.filter(item => 
                !['Voucher Redeem', 'Voucher Gift', 'Voucher Gift History'].includes(item.link_name)
            );

            // Sort children within dropdowns (unlocked children first, locked children last)
            list = list.map(item => {
                if (item.children && Array.isArray(item.children)) {
                    const sortedChildren = [...item.children].sort((a, b) => {
                        const lockedA = this.isFeatureLocked(a.link_name) ? 1 : 0;
                        const lockedB = this.isFeatureLocked(b.link_name) ? 1 : 0;
                        return lockedA - lockedB;
                    });
                    return { ...item, children: sortedChildren };
                }
                return item;
            });

            // Sort top-level menu items (unlocked items first, locked items last)
            return [...list].sort((a, b) => {
                const lockedA = this.isFeatureLocked(a.link_name) ? 1 : 0;
                const lockedB = this.isFeatureLocked(b.link_name) ? 1 : 0;
                return lockedA - lockedB;
            });
        },
        voucherSubItems() {
            if (!this.menuvisibility) return [];
            const subItems = [
                { link_name: 'Management', link_spesific: '/voucher' },
                { link_name: 'Voucher Redeem', link_spesific: '/voucher/redeem' },
                { link_name: 'Voucher Gift', link_spesific: '/voucher/gift' }
            ];
            // Filter based on parent menuvisibility to respect permissions
            const filtered = subItems.filter(sub => {
                const parentName = sub.link_name === 'Management' ? 'Voucher' : sub.link_name;
                return this.menuvisibility.some(item => item.link_name === parentName);
            });

            // Sort unlocked sub-items first, locked sub-items last
            return [...filtered].sort((a, b) => {
                const lockedA = this.isFeatureLocked(a.link_name) ? 1 : 0;
                const lockedB = this.isFeatureLocked(b.link_name) ? 1 : 0;
                return lockedA - lockedB;
            });
        },
        isVoucherActive() {
            return this.voucherSubItems.some(sub => this.isActiveVoucherChild(sub.link_spesific));
        }
    },
    watch: {
        "$store.state.FeatureFlag.pointControl": {
            handler() {
                this.initOpenDropdowns();
            },
            deep: true,
            immediate: true
        },
        "$store.state.FeatureFlag.voucherGift": {
            handler() {
                this.initOpenDropdowns();
            },
            deep: true,
            immediate: true
        },
        $route: {
            handler() {
                if (this.isVoucherActive) {
                    this.isVoucherExpanded = true;
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>
    .nav-link.menu-locked-disabled,
    .menu-locked-disabled {
        opacity: 0.55 !important;
        transition: opacity 0.2s ease, background-color 0.2s ease;
        cursor: pointer !important;
    }

    .nav-link.menu-locked-disabled:hover,
    .menu-locked-disabled:hover {
        opacity: 0.85 !important;
        background-color: rgba(255, 255, 255, 0.06);
    }

    .menu-locked-disabled .fas.fa-lock {
        opacity: 1 !important;
    }

    .lock-icon {
        color: var(--primary-color, #f39c12);
        font-size: 14px;
    }

    .dropdown-arrow {
        transition: transform 0.3s ease;
        font-size: 12px;
        opacity: 0.7;
    }
    .dropdown-arrow.rotate-up {
        transform: rotate(180deg);
    }
    
    /* Bold white bar ONLY on parent dropdown, NOT on child items */
    .nav-link.active:not(.child-link) {
        position: relative;
    }

    .nav-link.active:not(.child-link)::before {
        content: "" !important;
        position: absolute;
        left: 0;
        top: 2px;
        bottom: 2px;
        width: 3px;
        background-color: #fff;
        border-radius: 0 4px 4px 0;
    }

    /* Ensure child-link NEVER gets the bold bar */
    .child-link::before,
    .child-link.router-link-active::before,
    .child-link.router-link-exact-active::before {
        content: "" !important;
        display: block !important;
        position: absolute !important;
        left: -12px !important;
        top: 50% !important;
        bottom: auto !important;
        transform: translateY(-50%) !important;
        width: 12px !important;
        height: 1px !important;
        background-color: rgba(255, 255, 255, 0.3) !important;
        border-radius: 0 !important;
    }

    .dropdown-children {
        position: relative;
        padding-left: 32px;
        margin-top: 4px;
        margin-bottom: 8px;
    }

    /* Vertical rail line */
    .dropdown-children::before {
        content: "";
        position: absolute;
        left: 20px;
        top: 8px;
        bottom: 18px;
        width: 1px;
        background-color: rgba(255, 255, 255, 0.25);
    }

    .child-link {
        position: relative;
        overflow: visible;
        padding-left: 20px !important;
        padding-top: 9px !important;
        padding-bottom: 9px !important;
        margin-bottom: 2px;
        opacity: 0.6;
        transition: opacity 0.2s ease;
        border-radius: 0 !important;
        background: transparent !important;
    }

    /* Active child: brighter text/icon only, NO background */
    .child-link.router-link-active {
        opacity: 1 !important;
        background: transparent !important;
        font-weight: 600;
    }

    .child-link:hover {
        opacity: 1;
        background: transparent !important;
    }

    .sub-menu-icon {
        font-size: 14px;
        width: 18px;
        text-align: center;
    }
    .child-link.router-link-active .sub-menu-icon {
        opacity: 1;
    }

    .btn-custom-switch {
        padding: 0px;
        color: #fff;
    }
    .btn-custom-switch:focus {
        outline: none;
        border: none;
        box-shadow: none;
    }

    .btn-custom-switch:hover {
        color: #fff;
    }

    .for-collapse {
        background-color: transparent;
        color: white;
        cursor: pointer;
        border: none;
    }

    .profile-info {
        text-align: center; /* Centers the text */
    }

    .profile-info .small {
        color: #fff; /* White text */
        font-size: 0.75rem; /* Small font size */
    }


    .sidebar {
        height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .menu-custom {
        flex: 1;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 255, 255, 0.5) transparent;
    }

    .menu-custom::-webkit-scrollbar {
        width: 8px;
    }

    .menu-custom::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 10px;
    }

    .accordion-header {
        display: flex;
        align-items: center;
        text-decoration: none;
        transition: all 0.2s;
    }

    .accordion-icon {
        transition: transform 0.2s;
    }

    .rotated {
        transform: rotate(90deg);
    }

    .sub-link {
        font-size: 0.85rem;
        padding-top: 5px;
        padding-bottom: 5px;
        color: rgba(255, 255, 255, 0.8) !important;
        transition: color 0.2s;
        text-decoration: none;
    }

    .sub-link:hover, .sub-link.active {
        color: #fff !important;
        font-weight: bold;
    }

    /* Submenu Connecting Lines */
    .submenu-tree {
        position: relative;
        padding-left: 3rem; 
        margin-top: 0.25rem;
        list-style: none;
    }

    /* Vertical line */
    .submenu-tree::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 1.25rem; 
        left: 1.45rem; /* Centers under the 16px parent icon (16px padding + 8px half-width = 24px = 1.5rem, tweaked slightly for visual alignment) */
        width: 1px;
        background-color: rgba(255, 255, 255, 0.4);
    }

    /* Horizontal branch to each item */
    .submenu-tree .nav-item {
        position: relative;
    }

    .submenu-tree .nav-item::before {
        content: '';
        position: absolute;
        top: 50%;
        left: -1.55rem;
        width: 0.8rem;
        height: 1px;
        background-color: rgba(255, 255, 255, 0.4);
    }

    /* Hide the side vertical bar for submenu */
    #sidebarMenu .submenu-tree a.nav-link.sub-link.active::before {
        display: none !important;
    }

    @media (max-width: 827px) {
        .menu-custom {
            max-height: 400px;
            overflow-y: auto;
            background-color: rgba(255, 255, 255, 0);
        }
    }

    @media (max-height: 912px) {
        .menu-custom {
            max-height: 400px;
            overflow-y: auto;
            background-color: rgba(255, 255, 255, 0);
            scrollbar-width: thin;
            scrollbar-color: rgba(255, 255, 255, 0.5) transparent;
        }

        .menu-custom::-webkit-scrollbar {
            width: 8px;
        }
        
        .menu-custom::-webkit-scrollbar-thumb {
            background-color: rgba(255, 255, 255, 0.5);
            border-radius: 10px;
        }

        .menu-custom::-webkit-scrollbar-track {
            background: transparent;
        }
    }
</style>